import { Box, Content } from '@eluve/components';
import {
  useAppointmentTabNav,
  useAppointmentTranscript,
} from '@eluve/frontend-appointment-hooks';
import {
  AppointmentTabs,
  ExternalChartLink,
  SignedSummaryResult,
  SummaryTabContent,
  TranscriptTabContent,
} from '@eluve/frontend-feature-appointment';
import { AppointmentName, EluveAdminOnly } from '@eluve/smart-blocks';

import { AppointmentFilesDrawer } from './AppointmentFilesDrawer';
import { EluveAdminControls } from './EluveAdminControls';
import { appointmentLayoutStyles } from './appointmentLayoutStyles';
import { AppointmentSummaryFooter } from './components/AppointmentSummaryFooter';
import { ReadonlyAppointmentDetails } from './components/ReadonlyAppointmentDetails';

interface SignedAppointmentLayoutProps {
  appointmentId: string;
}

export const SignedAppointmentLayout: React.FC<
  SignedAppointmentLayoutProps
> = ({ appointmentId }) => {
  const { transcript } = useAppointmentTranscript();
  const { tab } = useAppointmentTabNav();
  return (
    <>
      <ReadonlyAppointmentDetails appointmentId={appointmentId} />
      <Content padded>
        <Box vStack className={appointmentLayoutStyles()}>
          <Box spaceBetween fullWidth className="p-2">
            <AppointmentName readonly />
            <EluveAdminOnly>
              <AppointmentFilesDrawer />
            </EluveAdminOnly>
          </Box>
          <EluveAdminControls readonlyMode />
          <ExternalChartLink appointmentId={appointmentId} />
          <AppointmentTabs />
          <TranscriptTabContent>
            <Box className="h-full overflow-y-auto pb-8">
              <p className="whitespace-pre-line px-2 align-baseline font-normal !leading-10 text-text-secondary">
                {transcript}
              </p>
            </Box>
          </TranscriptTabContent>
          <SummaryTabContent>
            <SignedSummaryResult appointmentId={appointmentId} />
          </SummaryTabContent>
        </Box>
      </Content>
      {tab === 'summary' && <AppointmentSummaryFooter />}
    </>
  );
};
